import axios from 'axios';

const API_URL = 'https://0n6bncfxva.execute-api.ap-southeast-1.amazonaws.com/prod';

export class ApiService {
  constructor() {

  }

  async getStock(stockCode, apiKey) {
    const url = `${API_URL}/getStock?stock=${stockCode}`;
    const resp = await axios.get(url, {
      headers: {
        'x-api-key': apiKey,
      }
    });
    return resp.data;
  }
}